/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Served_ColumnInputs */

const en_endpoint_served_column = /** @type {(inputs: Endpoint_Served_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Served`)
};

const zh_hans1_endpoint_served_column = /** @type {(inputs: Endpoint_Served_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已服务`)
};

const pt_br2_endpoint_served_column = /** @type {(inputs: Endpoint_Served_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atendidas`)
};

const es_endpoint_served_column = /** @type {(inputs: Endpoint_Served_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atendidas`)
};

const fr_endpoint_served_column = /** @type {(inputs: Endpoint_Served_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servis`)
};

const de_endpoint_served_column = /** @type {(inputs: Endpoint_Served_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedient`)
};

const ru_endpoint_served_column = /** @type {(inputs: Endpoint_Served_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обслужено`)
};

const it_endpoint_served_column = /** @type {(inputs: Endpoint_Served_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviti`)
};

/**
* | output |
* | --- |
* | "Served" |
*
* @param {Endpoint_Served_ColumnInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_served_column = /** @type {((inputs?: Endpoint_Served_ColumnInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Served_ColumnInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_served_column(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_served_column(inputs)
	if (locale === "es") return es_endpoint_served_column(inputs)
	if (locale === "fr") return fr_endpoint_served_column(inputs)
	if (locale === "de") return de_endpoint_served_column(inputs)
	if (locale === "ru") return ru_endpoint_served_column(inputs)
	if (locale === "it") return it_endpoint_served_column(inputs)
	return en_endpoint_served_column(inputs)
});